import { render, staticRenderFns } from "./OfficialBusinessTrip.vue?vue&type=template&id=98e192e0&scoped=true"
import script from "./OfficialBusinessTrip.vue?vue&type=script&lang=js"
export * from "./OfficialBusinessTrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e192e0",
  null
  
)

export default component.exports